import { z } from 'zod'

export const AuthResponseSchema = z.object({
  token: z.string(),
  require_password_change: z.boolean().optional(),
  is_disabled: z.boolean()
})

export type AuthResponse = z.infer<typeof AuthResponseSchema>
